import { PageHeader } from "@/components/shared";
import { ChannelOrdersPanel } from "@/components/channel/ChannelOrdersPanel";
import { useChannelDesk } from "@/lib/channel-desk";

const DistributorOrders = () => {
  const desk = useChannelDesk();
  return (
    <div className="space-y-6">
      <PageHeader
        title={`${desk.role} Orders Management`}
        description={`Track purchases from ${desk.availableWith} and manage sales orders from your downline channel.`}
      />
      <ChannelOrdersPanel mode="party" sections={["outgoing", "incoming"]} />
    </div>
  );
};

export default DistributorOrders;
